import { CRM_VERIFY_BODY_FIELDS } from './CrmVerification'

import type { CrmViolation } from './CrmVerification'

/**
 * Розкладає порушення 422 переходу на дві купки:
 *
 *  - **вимоги** — незаповнені поля картки власника (`SPEC-008` §5.4.2): модалку
 *    закриваємо, картку переводимо в редагування й підсвічуємо поля;
 *  - **тіло** — поля модалки підтвердження (`contractForwarder`,
 *    `contractNumber`, `contractDate`, `SPEC-008` §5.4.3): помилка лягає під
 *    поле модалки, і людина виправляє її там само.
 *
 * Тіло має лише `verify`. Усе, що не поле тіла, — до вимог, зокрема невідоме
 * поле: краще показати зайвий рядок у переліку картки, ніж загубити
 * пояснення.
 */
export interface ClassifiedViolations {
    requirements: CrmViolation[]
    body: CrmViolation[]
}

const BODY = new Set<string>(CRM_VERIFY_BODY_FIELDS)

export const classifyVerificationViolations = (
    violations: readonly CrmViolation[],
    options: { hasBody: boolean }
): ClassifiedViolations => {
    const result: ClassifiedViolations = { requirements: [], body: [] }

    for (const violation of violations) {
        if (options.hasBody && BODY.has(violation.field)) {
            result.body.push(violation)
        } else {
            result.requirements.push(violation)
        }
    }

    return result
}

/**
 * Порушення з відповіді 422 — у формі ядра (`field`) або легасі
 * (`propertyPath`). Порушення без поля відкидаємо: їх пояснює `serverMessage`.
 */
export const violationsOf = (body: unknown): CrmViolation[] => {
    if (body === null || typeof body !== 'object') return []

    const list = (body as { violations?: unknown }).violations

    if (!Array.isArray(list)) return []

    return list.flatMap((item): CrmViolation[] => {
        const record = (item ?? {}) as Record<string, unknown>
        const field = record['field'] ?? record['propertyPath']
        const message = record['message'] ?? record['title']

        return typeof field === 'string' && field !== '' && typeof message === 'string'
            ? [{ field, message }]
            : []
    })
}
